import React, { useState } from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Typography,
  Box
} from '@mui/material';
import './GolfOverallTable.scss';
import LeaderboardModal from './LeaderboardModal';

const GolfOverallTable = ({ scoreData, label, idToSet, teams, players, events }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);

  const handleClick = (team) => {
    const id = team?.id;
    setId(id);
    setOpen(true);
    //console.log("Team ID", id, "ID to Set", idToSet);
  };

  //console.log("Golf Overall Table Teams", scoreData, label);
    return (
        <>
          <TableContainer 
            component={Paper} 
            elevation={0} 
            className="golf-leaderboard-table-container"
          >
            <Table className="golf-leaderboard-table" aria-label="golf tournament leaderboard">
              <TableHead>
                <TableRow className="golf-leaderboard-header-row">
                  <TableCell className="golf-leaderboard-rank-cell">RANK</TableCell>
                  <TableCell className="golf-leaderboard-player-cell">{label}</TableCell>
                  <TableCell className="golf-leaderboard-total-cell">TO PAR</TableCell>
                  <TableCell className="golf-leaderboard-strokes-cell">R1</TableCell>
                  <TableCell className="golf-leaderboard-strokes-cell">R2</TableCell>
                  <TableCell className="golf-leaderboard-strokes-cell">STROKES</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {scoreData?.map((team, index) => (
                  <TableRow 
                    key={team.id || index} 
                    className={index % 2 === 0 ? 'golf-leaderboard-row-even' : 'golf-leaderboard-row-odd'}
                  >
                    <TableCell className="golf-leaderboard-rank-cell">
                      <Typography className="golf-leaderboard-rank-text">
                        {team.rank}
                      </Typography>
                    </TableCell>
                    <TableCell className="golf-leaderboard-player-cell">
                      <Box className="golf-leaderboard-player-info">
                        <Box className="golf-leaderboard-player-name-container">
                          {team.logoUrl && (
                            <img 
                              src={team.logoUrl} 
                              alt={`${team.name} logo`} 
                              className="golf-leaderboard-player-logo"
                            />
                          )}
                          <Typography variant="body1" component="span" className="golf-leaderboard-player-name" sx={{cursor: 'pointer'}} onClick={() => handleClick(team)}>
                            {team.name}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell className="golf-leaderboard-total-cell">
                      <Typography className="golf-leaderboard-total-text">
                        {team.total}
                      </Typography>
                    </TableCell>
                    <TableCell className="golf-leaderboard-strokes-cell">
                      <Typography className="golf-leaderboard-strokes-text">
                        {team.round1}
                      </Typography>
                    </TableCell>
                    <TableCell className="golf-leaderboard-strokes-cell">
                      <Typography className="golf-leaderboard-strokes-text">
                        {team.round2}
                      </Typography>
                    </TableCell>
                    <TableCell className="golf-leaderboard-strokes-cell">
                      <Typography className="golf-leaderboard-strokes-text">
                        {team.strokes}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {open && (
            <LeaderboardModal 
              open={open} 
              onClose={() => {
                setOpen(false);
                setId(null);
              }}              
              id={id} 
              teams={teams}
              players={players}
              events={events}
              idToSet={idToSet}
            />
          )}
        </>

      );
    };

export default GolfOverallTable;